<div class="cadastre-se" style="height: {{height}};" fxLayoutAlign="center center">
    <div class="cadastre-se-margin">
        <div fxLayout="column" fxLayoutGap="31px" fxLayoutAlign="center center">
            <span class="title2">
                {{title}}
            </span>

            <div fxLayout="row" fxLayout.lt-md="column" [fxLayout]="isColumn ? 'column' : 'row'" fxLayoutGap="95px"
                [fxLayoutGap.lt-xl]="isDynamic && EScreenSize.LAPTOP ? '40px' : null" fxLayoutGap.lt-md="20px"
                fxLayoutAlign="center center">
                <div [fxFlex]="currentLoggedUser ? '100' : 50">
                    <span class="description2">
                        Venha se preparar para exercer o seu papel de líder com competência e construir
                        relacionamentos que vão desbravar novos ambientes de negócios.
                    </span>
                </div>
                <div *ngIf="!currentLoggedUser">
                    <app-button (click)="openSignupModal()" [fontSize]="fontSizeButton" [txt]="'CADASTRE-SE AGORA'" [btnClass]="'btn-transparent cadastre-se-btn-w'"
                        [fontFamily]="'Oswald'"></app-button>
                </div>
            </div>
        </div>
    </div>
</div>
